import { appHttpRequest } from "@/utils/AppHttpRequest";
import { ciHttpRequest } from "@/utils/CiHttpRequest";
import {
    ISCMStockStatisticSearch,
    ISCMStockStatisticDetail,
    IStoreInventoryDetail,
    ISCMStockGoodsDetail,
    ISCMStockGoodsSearch,
    ISCMStockCheckGoodsSearch,
    ISCMStockCheckGoodsDetail,
    ISCMStockStatistics,
    ISCMStockMoveSearch,
    ISCMStockMoveDetail,
    ISCMShiftShelf,
    ISCMShelfQueryDetail,
    vrmPageRet
} from "./stockStatisticTypes";
import { IPage } from "@/types/FmsTypes";

export interface ISCMPage<T, S> extends IPage<T> {
    statistics: S
}
export interface IStatistics {
    totalInventoryAmount: number,
    totalInventoryNum: number,
    stockNum: number,
    stockAmount: number,
}


class StockStatisticService {
    //库存统计页
    async scmPage(searchVo: ISCMStockStatisticSearch) {
        const apiUrl = "/scm2/inventory/summary/report/page";
        return await appHttpRequest.post<ISCMPage<ISCMStockStatisticDetail, ISCMStockStatistics>>(apiUrl, searchVo);
    }
    async ciPage(searchVo: ISCMStockStatisticSearch) {
        const apiUrl = "/ci-storage/stock/findPage";
        return await ciHttpRequest.post<ISCMPage<ISCMStockStatisticDetail, ISCMStockStatistics>>(apiUrl, searchVo);
    }
    async vrmPage(searchVo: ISCMStockStatisticSearch) {
        const apiUrl = "/vrm2/stock/findPage";
        return await appHttpRequest.post<vrmPageRet[]>(apiUrl, searchVo);
    }
    async bcmPage(searchVo: ISCMStockStatisticSearch) {
        const apiUrl = "/bcm/stock/findPage";
        return await appHttpRequest.post<vrmPageRet[]>(apiUrl, searchVo);
    }
    // 头部统计
    async scmStatistics(searchVo: ISCMStockStatisticSearch) {
        const apiUrl = "/scm2/inventory/summary/report/statistics";
        return await appHttpRequest.post<IStatistics>(apiUrl, searchVo);
    }
    async ciStatistics(searchVo: ISCMStockStatisticSearch) {
        const apiUrl = "/ci-storage/stock/details/total/amount";
        return await ciHttpRequest.post<IStatistics>(apiUrl, searchVo, { timeout: 30000 });
    }
    async vrmStatistics(searchVo: ISCMStockStatisticSearch) {
        const apiUrl = "/vrm2/stock/details/total/amount";
        return await appHttpRequest.post<IStatistics>(apiUrl, searchVo);
    }
    async bcmStatistics(searchVo: ISCMStockStatisticSearch) {
        const apiUrl = "/bcm/stock/details/total/amount";
        return await appHttpRequest.post<IStatistics>(apiUrl, searchVo);
    }
    //查各配件在分店下的库存
    async stockShopPage(searchVo: ISCMStockStatisticSearch) {
        const apiUrl = "/scm2/stock/statistic/storeInventory";
        return await appHttpRequest.post<ISCMPage<ISCMStockStatisticDetail, ISCMStockStatistics>>(apiUrl, searchVo);
    }
    //占用明细查询接口
    async occupyDeatil(searchVo: any) {
        const apiUrl = "/scm2/statistics/occupyDeatil";
        return await appHttpRequest.post<IStatistics>(apiUrl, searchVo);
    }
    //统计金额展示
    async totalAmount(id: string) {
        const apiUrl = `/scm2/stock/statistic/statistics/${id}`;
        return await appHttpRequest.get<ISCMStockStatistics>(apiUrl);
    }

    async export(searchVo: ISCMStockStatisticSearch, userBranch: string) {
        let apiUrl = "";
        if (userBranch === 'scm') {
            apiUrl = "/scm2/inventory/summary/report/export";
            return await appHttpRequest.postFile(apiUrl, searchVo, { timeout: 300000 });
        }
        else if (userBranch === 'vrm') {
            apiUrl = "/vrm2/stock/export";
            return await appHttpRequest.postFile(apiUrl, searchVo, { timeout: 300000 });
        }
        else if (userBranch === 'bcm') {
            apiUrl = "/bcm/stock/export";
            return await appHttpRequest.postFile(apiUrl, searchVo, { timeout: 300000 });
        }
        else if (userBranch === 'ci') {
            apiUrl = "/ci-analyze/stock/statistics/exportFms";
            return await ciHttpRequest.postFile(apiUrl, { "searchItem": searchVo }, { timeout: 300000 });
        }
        else {
            return await appHttpRequest.postFile(apiUrl, searchVo, { timeout: 300000 });
        }
    }

    //转移库存记录
    async movePage(searchVo: ISCMStockMoveSearch) {
        const apiUrl = "/scm2/stock/statistic/move/listPage";
        return await appHttpRequest.post<IPage<ISCMStockMoveDetail>>(apiUrl, searchVo);
    }

    //分页查询库存列表-用于销售
    async pageSale(searchVo: ISCMStockGoodsSearch) {
        const apiUrl = "/scm2/stock/statistic/findPageBySale";
        return await appHttpRequest.post<IPage<ISCMStockGoodsDetail>>(apiUrl, searchVo);
    }

    //分页查询库存列表
    async pageStock(searchVo: ISCMStockCheckGoodsSearch) {
        const apiUrl = "/scm2/stock/statistic/listPage";
        return await appHttpRequest.post<IPage<ISCMStockCheckGoodsDetail>>(apiUrl, searchVo);
    }

    //库存商品移库
    async shiftShelf(arr: ISCMShiftShelf[]) {
        const apiUrl = "/scm2/stock/statistic/shift";
        return await appHttpRequest.post<boolean>(apiUrl, arr);
    }

    //还原移库
    async reduction(id: string) {
        const apiUrl = `/scm2/stock/statistic/reduction/${id}`;
        return await appHttpRequest.get<boolean>(apiUrl);
    }
    //移库下载模板
    async downloadTpl() {
        const appPageUrl = "/scm2/stock/statistic/move/downloadTpl";
        return await appHttpRequest.getFile(appPageUrl);
    }

    //占用库存可查明细
    async stockDetail(obj: { shopId: string, materialCode: string, shelfCode: string }) {
        const apiUrl = `/scm2/stock/statistic/holdDetails`;
        return await appHttpRequest.post<ISCMShelfQueryDetail[]>(apiUrl, obj);
    }
    //云修分店库存
    async vrm2Inventory(materialCode: string) {
        const apiUrl = `/vrm2/stock/store/inventory/${materialCode}`;
        return await appHttpRequest.get<IStoreInventoryDetail[]>(apiUrl);
    }
    //供应链分店库存
    async scm2Inventory1(materialCode: string) {
        const apiUrl = `/scm2/stock/statistic/store/inventory/${materialCode}`;
        return await appHttpRequest.get<IStoreInventoryDetail[]>(apiUrl);
    }

    //供应链分店库存
    async scm2Inventory(params: object) {
        const apiUrl = `/scm2/inventory/summary/report/selectShopInventorySummary`;
        return await appHttpRequest.post<IStoreInventoryDetail[]>(apiUrl, params);
    }
    //客车分店库存
    async bcmInventory(materialCode: string) {
        const apiUrl = `/bcm/stock/store/inventory`;
        return await appHttpRequest.post<IStoreInventoryDetail[]>(apiUrl, { materialCode });
    }
    //库存核验导出
    async statisticCheck(params: object) {
        const apiUrl = `/scm2/stock/statistic/check`;
        return await appHttpRequest.postFile(apiUrl, params, { timeout: 300000 });
    }
}

export const stockStatisticService = new StockStatisticService();